import { axios } from './config';

export const getChangeLogs = (payload) => {
	return axios.post(`/audit-logs`, payload);
};
